import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3","key":"svg-0"}]]

const IconToolsKitchen2 = createReactComponent('outline', 'tools-kitchen-2', 'ToolsKitchen2', __iconNode);

export default IconToolsKitchen2;